import React, { useEffect, useState } from 'react';

// Cell 6 · Bullet Matrix v2 switch + group allowlist for this quote type.
export const BulletV2Panel = ({ api, engine, groupsAllow, setField }) => {
  const [groups, setGroups] = useState([]);
  useEffect(() => {
    api.get('/bullet-groups').then(r => setGroups((r.data.groups || []).filter(g => g.show))).catch(() => {});
  }, [api]);
  const on = engine === 'v2';
  const allow = Array.isArray(groupsAllow) ? new Set(groupsAllow) : null;
  const toggle = (code, checked) => {
    const cur = allow ? new Set(allow) : new Set(groups.map(g => g.code));
    if (checked) cur.add(code); else cur.delete(code);
    setField('qt_bullet_v2_groups', Array.from(cur));
  };
  return (
    <div className="border border-sky-300 rounded-md overflow-hidden" data-testid="quotation-bullet-v2-panel">
      <div className="px-3 py-2 bg-sky-50 border-b border-sky-200 flex items-center gap-2 flex-wrap">
        <span className="text-[10px] font-mono font-bold text-sky-800">6</span>
        <h4 className="text-xs font-bold text-sky-900 flex-1">"Repairs Detailed as Follows:" · NEW grouped bullets (Bullet Matrix v2)</h4>
        <label className="flex items-center gap-1.5 text-xs font-semibold text-sky-900">
          <input type="checkbox" data-testid="quotation-bullet-v2-toggle" checked={on}
            onChange={e => setField('qt_bullet_engine', e.target.checked ? 'v2' : '')} />
          Use new bullets on this quote type
        </label>
      </div>
      <div className="p-3 space-y-2">
        <p className="text-[11px] text-slate-600">
          {on ? 'ON — the PDF uses the grouped bullets below (1–5 = 1 column, 6–12 = 2 columns, 13+ = 3 columns with short tags). The old allowlist is ignored.'
            : 'OFF — the PDF still uses the old allowlist below. Tick to switch this quote type over. Wording is edited in Admin → Quote Bullets.'}
        </p>
        {allow && (
          <button type="button" data-testid="quotation-bullet-v2-reset-all" onClick={() => setField('qt_bullet_v2_groups', null)}
            className="text-[11px] px-2 py-0.5 rounded-full border border-sky-400 bg-white text-sky-700 hover:bg-sky-100 transition-colors">
            Reset to all groups ({allow.size} of {groups.length} ticked)
          </button>
        )}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-1" data-testid="quotation-bullet-v2-groups">
          {groups.map(g => (
            <label key={g.code} className="flex items-start gap-1.5 text-[11px]" data-testid={`quotation-bullet-v2-group-${g.code}`}>
              <input type="checkbox" checked={allow ? allow.has(g.code) : true} onChange={e => toggle(g.code, e.target.checked)} />
              <span><b className="font-mono">{g.code}</b> {g.title}</span>
            </label>
          ))}
        </div>
      </div>
    </div>
  );
};
